// import React, { useState } from "react";

// const OurVision = () => {
//   const [isExpanded, setIsExpanded] = useState(false);

//   return (
//     <div className="text-gray-800 font-sans">
//       {/* Mission Content Section */}
//       <section className="py-16 px-4 md:px-20 bg-white grid md:grid-cols-2 gap-10">
//         <img
//           src="https://res.cloudinary.com/dxdvcplbl/image/upload/v1754940459/DJI_20250811180100_0084_D-min_bws9ko.jpg"
//           alt="Golf Course"
//           className="w-full h-auto rounded-lg"
//         />
//         <div>
//           <h2 className="text-xl font-bold mb-4">Our Vision</h2>
//           <div
//             className={`overflow-hidden transition-all duration-500 ease-in-out ${
//               isExpanded ? "max-h-[1000px]" : "max-h-[6em]"
//             }`}
//           >
//             <p className="mb-4">
//               "To be the leading golf and leisure destination in Northern
//               Bangladesh, inspiring a passion for golf and wellness, while
//               upholding the highest standards of service, history, integrity,
//               and environmental sustainability. "
//             </p>
//           </div>
//           {/* <button
//             onClick={() => setIsExpanded(!isExpanded)}
//             className="text-black mt-4 text-sm underline hover:text-black/70 transition-colors duration-300"
//           >
//             {isExpanded ? "READ LESS" : "READ MORE"}
//           </button> */}
//         </div>
//       </section>
//     </div>
//   );
// };

// export default OurVision;

import { Eye, Star, Globe, Award, Zap, ArrowRight } from "lucide-react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const OurVision = () => {
  // const [isExpanded, setIsExpanded] = useState(false);

  const visionRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (visionRef.current) {
        visionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 1000);
  });

  const navigate = useNavigate();

  const visionPillars = [
    {
      icon: <Star className="w-6 h-6" />,
      title: "Excellence",
      description: "Setting the highest standards in golf and leisure",
    },
    {
      icon: <Globe className="w-6 h-6" />,
      title: "Sustainability",
      description: "Protecting and preserving our natural environment",
    },
    {
      icon: <Award className="w-6 h-6" />,
      title: "Integrity",
      description: "Upholding trust and ethical practices",
    },
    {
      icon: <Zap className="w-6 h-6" />,
      title: "Innovation",
      description: "Embracing progress and modern amenities",
    },
  ];

  return (
    <div className="font-sans">
      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-center justify-center text-white overflow-hidden">
        {/* Background Image with Gradient Overlay */}
        <div className="absolute inset-0">
          <img
            src="https://res.cloudinary.com/dxdvcplbl/image/upload/v1754940459/DJI_20250811180100_0084_D-min_bws9ko.jpg"
            alt="RGCC Vision"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 via-indigo-800/60 to-purple-900/40"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-4xl px-4 md:px-8 text-center">
          <div className="inline-flex items-center gap-2 mb-6">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500/20 to-indigo-500/20 backdrop-blur-sm border border-blue-400/30 flex items-center justify-center">
              <Eye className="w-6 h-6 text-blue-300" />
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
            Our Inspiring{" "}
            <span className="relative inline-block">
              <span className="relative z-10 bg-gradient-to-r from-blue-300 to-indigo-300 bg-clip-text text-transparent">
                Vision
              </span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-blue-500/30 to-indigo-500/30 -rotate-1"></span> */}
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto leading-relaxed">
            Shaping the future of golf in Northern Bangladesh with purpose and
            passion
          </p>
        </div>
      </section>

      {/* Vision Content */}
      <div className="bg-gradient-to-br from-blue-50/30 via-white to-indigo-50/30">
        <section className="py-16 md:py-24 px-4 md:px-8 max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Image Column */}
            <div className="relative group">
              <div className="absolute -inset-4 bg-gradient-to-r from-blue-400 to-indigo-400 rounded-2xl blur-xl opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://res.cloudinary.com/dxdvcplbl/image/upload/v1754940459/DJI_20250811180100_0084_D-min_bws9ko.jpg"
                  alt="RGCC Vision Future"
                  className="w-full h-auto transform group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent"></div>
              </div>
            </div>

            {/* Text Column */}
            <div>
              <div className="inline-flex items-center gap-2 mb-4">
                <span className="w-8 h-0.5 bg-gradient-to-r from-blue-500 to-indigo-500"></span>
                <span className="text-sm font-semibold tracking-widest text-blue-600 uppercase">
                  Future Forward
                </span>
                <span className="w-8 h-0.5 bg-gradient-to-r from-indigo-500 to-blue-500"></span>
              </div>

              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Our Vision Statement
              </h2>

              <div
                ref={visionRef}
                className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 md:p-8 mb-8 border border-blue-100"
              >
                <blockquote className="text-2xl md:text-3xl font-medium text-gray-800 leading-relaxed italic">
                  "To be the leading golf and leisure destination in Northern
                  Bangladesh, inspiring a passion for golf and wellness, while
                  upholding the highest standards of service, history,
                  integrity, and environmental sustainability."
                </blockquote>
              </div>

              <p className="text-gray-600 leading-relaxed mb-8">
                Our vision serves as our north star, guiding every decision and
                innovation at Rangpur Golf & Country Club. We're not just
                building a golf course; we're creating a legacy that will
                inspire generations of golfers to come.
              </p>

              {/* Vision Pillars */}
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  Our Core Pillars
                </h3>
                <div className="grid sm:grid-cols-2 gap-6">
                  {visionPillars.map((pillar, index) => (
                    <div
                      key={index}
                      className="bg-white/80 backdrop-blur-sm rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md hover:border-blue-100 transition-all duration-300 group"
                    >
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                          <div className="text-blue-600">{pillar.icon}</div>
                        </div>
                        <div>
                          <h4 className="font-bold text-gray-900">
                            {pillar.title}
                          </h4>
                          <p className="text-gray-600 text-sm">
                            {pillar.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Call to Action */}
              <div className="flex flex-col sm:flex-row items-center gap-6 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-100">
                <div className="flex-1">
                  <h4 className="text-xl font-bold text-gray-900 mb-2">
                    Be Part of Our Vision
                  </h4>
                  <p className="text-gray-600">
                    Join us in shaping the future of golf in Northern Bangladesh
                  </p>
                </div>
                <button
                  onClick={() => navigate("/membership")}
                  className="inline-flex items-center gap-2 px-8 py-3 rounded-full font-bold text-white bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 transition-all duration-300 transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl"
                >
                  Explore Membership
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>

          {/* Future Goals Section */}
          <div className="mt-20 bg-white rounded-2xl p-8 md:p-12 border border-gray-100 shadow-sm">
            <div className="text-center max-w-4xl mx-auto">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-100 mb-6">
                <Award className="w-8 h-8 text-blue-600" />
              </div>

              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
                Our Vision for the Future
              </h3>

              <div className="grid md:grid-cols-3 gap-8 mt-12">
                <div className="text-center p-6 hover:bg-blue-50/50 rounded-xl transition-colors duration-300">
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-100 to-indigo-100 flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl font-bold text-blue-600">
                      2025
                    </span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">
                    Digital Transformation
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Implementing cutting-edge technology for enhanced member
                    experience
                  </p>
                </div>
                <div className="text-center p-6 hover:bg-blue-50/50 rounded-xl transition-colors duration-300">
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-indigo-100 to-blue-100 flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl font-bold text-indigo-600">
                      2026
                    </span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">
                    Sustainability Initiative
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Achieving carbon neutrality and environmental certification
                  </p>
                </div>
                <div className="text-center p-6 hover:bg-blue-50/50 rounded-xl transition-colors duration-300">
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-100 to-indigo-100 flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl font-bold text-blue-600">
                      2027
                    </span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">
                    National Recognition
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Becoming the premier golf destination in Bangladesh
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default OurVision;
